import { render, staticRenderFns } from "./dashboard-total-sales.vue?vue&type=template&id=4d40d85e&"
import script from "./dashboard-total-sales.vue?vue&type=script&lang=js&"
export * from "./dashboard-total-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports